// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-horizontal .form-group[data-v-79ca2f30] {\n  margin-left: 0;\n  margin-right: 0;\n}\nform.school-form .help-block[data-v-79ca2f30] {\n  padding-left: 0;\n}\n.input-group span.input-group-addon i[data-v-79ca2f30] {\n  width: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
